import { useState } from 'react';
import { Link } from 'react-router-dom';
import { FAQ_INICIO } from '@/seo/datos';

// Las mismas preguntas van en los datos estructurados (FAQPage) de la portada
const FAQS = FAQ_INICIO;

export default function SeoFaqSection() {
  const [open, setOpen] = useState<number | null>(null);

  return (
    <section className="py-16 md:py-20 bg-white" aria-label="Preguntas frecuentes sobre paneles solares en Cuba">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">

          {/* Left — heading + CTA */}
          <div className="lg:sticky lg:top-28">
            <span className="text-amber-600 text-xs font-bold uppercase tracking-widest">Preguntas frecuentes</span>
            <h2
              className="font-extrabold text-stone-900 mt-3 mb-4"
              style={{ fontSize: 'clamp(1.75rem, 3.5vw, 2.75rem)', letterSpacing: '-0.025em', lineHeight: 1.15 }}
            >
              Todo sobre paneles solares e instalaciones eléctricas en La Habana
            </h2>
            <p className="text-stone-500 text-base leading-relaxed mb-8">
              Resolvemos tus dudas sobre energía solar, instalaciones eléctricas y envíos en La Habana. Si tienes más preguntas, contáctanos directamente.
            </p>
            <div className="flex flex-col sm:flex-row gap-3">
              <Link
                to="/products"
                className="inline-flex items-center justify-center gap-2 bg-amber-500 hover:bg-amber-400 text-black font-semibold px-6 py-3 rounded-full text-sm transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-store-2-line" />
                Ver catálogo completo
              </Link>
              <Link
                to="/contact"
                className="inline-flex items-center justify-center gap-2 border border-stone-300 hover:border-stone-400 text-stone-600 font-semibold px-6 py-3 rounded-full text-sm transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-whatsapp-line" />
                Contactar
              </Link>
            </div>

            {/* Trust mini-stats */}
            <div className="flex items-center gap-6 mt-10 pt-8 border-t border-gray-200">
              {[
                { value: '+500', label: 'Equipos vendidos' },
                { value: '100%', label: 'Envíos La Habana' },
                { value: '5★', label: 'Valoración media' },
              ].map((s) => (
                <div key={s.label}>
                  <div className="font-extrabold text-stone-900 text-xl" style={{ letterSpacing: '-0.02em' }}>{s.value}</div>
                  <div className="text-stone-500 text-xs font-medium mt-0.5">{s.label}</div>
                </div>
              ))}
            </div>
          </div>

          {/* Right — accordion */}
          <div className="flex flex-col gap-3">
            {FAQS.map((faq, i) => (
              <div
                key={i}
                className="rounded-2xl overflow-hidden transition-all duration-200"
              style={{ background: '#f9fafb', border: '1px solid #e5e7eb' }}
              >
                <button
                  onClick={() => setOpen(open === i ? null : i)}
                  className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left cursor-pointer"
                  aria-expanded={open === i}
                >
                  <span className="font-semibold text-stone-800 text-sm leading-snug">{faq.q}</span>
                  <span
                    className="w-7 h-7 flex items-center justify-center rounded-full shrink-0 transition-transform duration-200"
                    style={{ background: '#f3f4f6', transform: open === i ? 'rotate(45deg)' : 'rotate(0deg)' }}
                  >
                    <i className="ri-add-line text-stone-500 text-sm" />
                  </span>
                </button>
                <div
                  style={{
                    maxHeight: open === i ? '300px' : '0',
                    overflow: 'hidden',
                    transition: 'max-height 0.3s ease',
                  }}
                >
                  <p className="px-5 pb-5 text-sm text-stone-500 leading-relaxed">
                    {faq.a}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
